// because the plugin uses nope & like I wrote this little plugin to
// transform the position to something more professional, clear and maintainable

export default {
	install(Vue) {
		Vue.prototype.$convertType = ({ type, reverse }) => {
			let position

			if (reverse) {
				if (type === false) {
					position = 'nope'
				}
				if (type === true) {
					position = 'like'
				}
			} else {
				if (type === 'nope') {
					position = false
				}
				if (type === 'like') {
					position = true
				}
			}

			return position
		}
	}
}
